module.exports = __webpack_public_path__ + "img/1792493321103.0663a1a1.png";